import React from 'react';
import {FilterSelectorsType, FilterStateType} from "../../model/types";
import {OnChangeFilterHandler} from "../../model/useFilterHandler";
import FilterSelectedRenderer from "./filter-selected/FilterSelectedRenderer";
import {StyledCountProducts, StyledFilterSelectedWrapper} from "./filter-selected/style";
import FilterActionReset from "./FilterActionReset";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

interface IProps {
    filtersSelector: FilterSelectorsType,
    filterState: FilterStateType,
    countProducts: number,
    onChangeFilter: OnChangeFilterHandler,
    onResetFilters: () => void,
}

const ProductFilterSelected = ({
                                   onResetFilters,
                                   filtersSelector,
                                   onChangeFilter,
                                   filterState,
                                   countProducts
                               }: IProps) => {


    return (
        <StyledFilterSelectedWrapper className={GLOBAL_STYLE_CONFIG.splitByPrefix("filter-selected")}>
            <StyledCountProducts
                className={GLOBAL_STYLE_CONFIG.splitByPrefix("filter-find-count")}>
                Знайдено {countProducts} варіантів
            </StyledCountProducts>

            <FilterSelectedRenderer filtersSelector={filtersSelector} filterState={filterState}
                                    onChangeFilter={onChangeFilter}/>

            {!!Object.keys(filterState ?? {}).length && <FilterActionReset onResetFilters={onResetFilters}/>}
        </StyledFilterSelectedWrapper>
    );
};

export default ProductFilterSelected;